import { Name as EntityName } from '../../entity';

export const TYPE = `${EntityName.ACTION_PREFIX}PLANNER:remove_plan`;

export type Payload = string;
